import * as classNames from 'classnames'
import * as React from 'react'
import WarningWhiteIcon from '../icons/ui/WarningWhite'

export interface IErrorMessageProps {
  visible?: boolean
  children?: any
  className?: string
}

const ErrorMessage = (props: IErrorMessageProps) => {
  const { visible = true, children, className = '' } = props

  if (!visible) {
    return null
  }

  return (
    <div className={classNames(className, 'flex flex-row items-center p1 bg-orange')}>
      <WarningWhiteIcon className='icon--small' />
      <span className='font-white font-small ml1'>{children}</span>
    </div>
  )
}

export default ErrorMessage



// WEBPACK FOOTER //
// ./src/components/ui/ErrorMessage.tsx